import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_AUTO_LIST_SCHEMA = Object.freeze({
  IDENTIFIER: null,
});
const RECORD = generateSchema(TRACKING_AUTO_LIST_SCHEMA);
const KEYS: any = generateKeys(TRACKING_AUTO_LIST_SCHEMA);

export class AlertBannerTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.alert_banner;
  }

  get properties() {
    return this.toJS();
  }
}
